import { useQuery } from '@tanstack/react-query'

import dateToISOStr from '@/utils/helpers/dateToISOStr'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_SEARCH_PATH } from '@/services'

export const useSearchBookingRepair = (
  { tokenId, repairTypeId, areaId, date, location },
  config = {},
) => {
  const api = useLegacyPublicApi()
  const dateStr = dateToISOStr(date, false)
  const locationStr = location ? `${location.lat}-${location.lng}` : ''
  return useQuery({
    queryKey: [
      'search-booking-repair',
      tokenId,
      repairTypeId,
      areaId,
      locationStr,
      dateStr,
    ],
    queryFn: async () => {
      const hasCoordinates = location && location.lat && location.lng
      const hasAddress = location?.address?.length > 0
      const hasArea = areaId?.length > 0
      const hasLocation = !!hasCoordinates || !!hasAddress || !!hasArea
      if (!api || !tokenId || !date || !repairTypeId || !hasLocation)
        return false

      const url = SERVICE_BOOKING_SEARCH_PATH.replace('{tokenId}', tokenId)

      try {
        const { data } = await api.get(url, {
          params: {
            date: dateStr,
            repairType: repairTypeId,
            ...(hasArea && { area: areaId }),
            ...(hasCoordinates && { lat: location?.lat }),
            ...(hasCoordinates && { lng: location?.lng }),
            ...(hasAddress && { address: location?.address }),
          },
        })
        return data
      } catch (err) {
        return err
      }
    },
    ...config,
  })
}
